import * as React from 'react'
import {
  Box,
  Button,
  Container,
  Typography,
} from '@mui/material'

import AppBar from '../../components/AppBar'
import { AppsFlyerLinks } from '../../constants/appsflyer_links'

const CreditPaymentOkPage: React.FC = () => {
  // アプリに戻る処理
  const handleReturn = () => {
    const returnUrl = AppsFlyerLinks.CREDIT_PAYMENT_COMPLETE
    window.location.href = returnUrl
  }

  return (
    <div>
      <AppBar payType='クレジットカード決済' />

      <Box
        py={3}
        textAlign="center"
      >
        <Container>
          <Typography variant="h6" gutterBottom>
            クレジットカード決済の登録に成功しました！
          </Typography>

          <Button
            fullWidth
            variant="contained"
            size="large"
            color="primary"
            style={{
              borderRadius: '24px',
              marginTop: '16px'
            }}
            onClick={handleReturn}
          >
            アイカサアプリに戻る
          </Button>
        </Container>
      </Box>
    </div>
  )
}

export default CreditPaymentOkPage
